// Story 7.6 — the GreenholdFrame: shared chrome every feed card sits in.
//
// Antique-gold hairline border (~40% opacity) on a forest-800 ground.
// This frame is what makes the feed feel like Greenhold regardless of
// what the card contains. `muted` is the SilenceCard's soft-background
// variant. No motion, no hover animation (Sally's v1 rule).

import type { ReactNode } from "react";

import { cn } from "@greenhold/components";

export function GreenholdFrame({
  children,
  muted = false,
  className,
}: {
  children: ReactNode;
  muted?: boolean;
  className?: string;
}) {
  return (
    <article
      className={cn(
        // min-w-0 + overflow-wrap:anywhere: card text (posts, titles,
        // excerpts) must wrap even for pathological unbroken strings —
        // without this a long token walks straight off the viewport.
        "min-w-0 overflow-hidden rounded-lg border p-6 [overflow-wrap:anywhere]",
        muted
          ? "border-brand-gold-500/20 bg-brand-forest-800/60"
          : "border-brand-gold-500/40 bg-brand-forest-800",
        className,
      )}
      data-testid="greenhold-frame"
    >
      {children}
    </article>
  );
}

/**
 * Subtle antique-gold "Pinned" chip — rendered ABOVE the frame (between
 * top bar and card) when `is_pinned`. Non-dismissable at v1.
 */
export function PinnedChip() {
  return (
    <span
      className="mb-1.5 inline-block rounded-full border border-brand-gold-500/40 px-2 py-0.5 font-body text-[0.65rem] uppercase tracking-wide text-brand-gold-300"
      data-testid="pinned-chip"
    >
      Pinned
    </span>
  );
}
